module.exports = __webpack_public_path__ + "img/sort-ascending.98428b66.svg";